import { render, staticRenderFns } from "./BreathingLight.vue?vue&type=template&id=0d4ff5d0&scoped=true"
import script from "./BreathingLight.vue?vue&type=script&lang=js"
export * from "./BreathingLight.vue?vue&type=script&lang=js"
import style0 from "./BreathingLight.vue?vue&type=style&index=0&id=0d4ff5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4ff5d0",
  null
  
)

export default component.exports